import script from "./JaMaterialUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialUpload.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialUpload.vue?vue&type=style&index=0&id=745e93fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745e93fb"]])

export default __exports__